import React, { useState, useEffect } from 'react';
import { NoDataTab } from 'javascripts/analytics/components/NoDataTab';
import { CVUploadButton } from './CVUploadButton.wjs';
import { checkCVExists } from 'js/profiles/api/curriculumVitaeApi';

export const CVAnalyticsTab = ({ title }) => {
  const [hasCv, setHasCv] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkStatus = async () => {
      try {
        const exists = await checkCVExists();
        setHasCv(exists);
        setIsLoading(false);
      } catch (error) {
        console.error('Error checking CV status:', error);
        setIsLoading(false);
      }
    };

    checkStatus();
  }, []);

  if (isLoading) {
    return (
      <div className="panel panel-flat u-taCenter a-fadeInDown">
        <div className="panel-body u-p12x u-tcGrayDarkest">
          <div className="u-mt5x">
            <i className="fa fa-spin fa-spinner u-fs36"></i>
            <p>Checking CV status...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <NoDataTab
      title={title}
      details={
        hasCv
          ? 'Analytics update continuously as visitors view your CV.'
          : "You haven't uploaded a CV yet. Upload it to track how many people view your CV."
      }
      customUploadButton={!hasCv ? <CVUploadButton hasCv={hasCv} /> : null}
      noUploadButton={hasCv}
    />
  );
};
